import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from "../../../base-component/base-component";

import UserIcon from 'i5-user';

import Classes from 'classnames'

class MentionSuggestionsEntry extends BaseComponent {

    constructor(props) {
        super(props);

    }

    render() {
        const {
            mention,
            theme,
            searchValue, // eslint-disable-line no-unused-vars
            isFocused, // eslint-disable-line no-unused-vars
            id, onMouseDown, onMouseEnter, onMouseUp, role, className
        } = this.props;

        const classes = Classes("mentions-suggestions-entry", {
            isFocused: isFocused
        });

        return (
            <div aria-selected={this.props['aria-selected']}
                 id={id}
                 onMouseDown={onMouseDown}
                 onMouseEnter={onMouseEnter}
                 onMouseUp={onMouseUp}
                 role={role}
                 className={classes}>
                {mention.type === gd.const.editorLink.type.USER &&
                <UserIcon userId={mention.userId} hint={false} size="tiny"/>}
                {mention.type === gd.const.editorLink.type.SWITCH_OPTIONS &&
                <div className="option-icon">...</div>}
                {mention.name}
            </div>
        );
    }
}

module.exports = MentionSuggestionsEntry;